import { getThemeFromQuery } from '../theme-controllers/getUserTheme';

let hideStyleElement: HTMLStyleElement | null = null;

/**
 * Скрывает жука (YndxBug), если сервис встроен как виджет (определяется по наличию _theme в query).
 */
export function applyBugVisibility() {
    const isEmbedded = getThemeFromQuery() !== null;

    if (isEmbedded) {
        hideBug();
    } else {
        revealBug();
    }
}

function hideBug() {
    if (hideStyleElement) {
        return;
    }

    hideStyleElement = document.createElement('style');
    hideStyleElement.type = 'text/css';
    hideStyleElement.innerHTML = '.YndxBug { display: none !important; }';
    document.head.appendChild(hideStyleElement);
}

function revealBug() {
    if (!hideStyleElement || !hideStyleElement.parentNode) {
        return;
    }

    hideStyleElement.remove();
    hideStyleElement = null;
}
